// extracted by mini-css-extract-plugin
module.exports = {"backToBottom":"widgets-item-BackToBottom_backToBottom__y3sJS","showBottom":"widgets-item-BackToBottom_showBottom__1T22l"};